<template>
    <div class="jia-wrapper">
        <div class="chart-item">
            <p>混凝土</p>
            <div class="total-wrapper">
                <div class="total-item">
                    本月售价(元/方):<span>{{ hntTotal.bysj }}</span>
                </div>
                <div class="total-item">
                    本年度均价(元/方):<span>{{ hntTotal.bnjj }}</span>
                </div>
            </div>
            <div id="hntChart" class="chart-wrapper hntChart"></div>
        </div>
        <div class="chart-item">
            <p>产品标号</p>
            <!-- <div class="total-wrapper">
                <div class="total-item">
                    本月售价(元/方):<span>{{ sjTotal.bysj }}</span>
                </div>
                <div class="total-item">
                    本年度均价(元/方):<span>{{ sjTotal.bnjj }}</span>
                </div>
            </div> -->
            <div id="sjChart" class="chart-wrapper sjChart"></div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    data() {
        return {
            hntData: [],
            sjData: [],
            hntTotal: {},
            sjTotal: {},
            Year: '',
            Month: '',
        };
    },
    created() {
        this.Year = new Date().getFullYear();
        this.Month = new Date().getMonth() + 1;
    },
    mounted() {
        this.getTotal(0);
        // this.getTotal(1);
        this.getStatistics(0);

        // 产品标号
        this.getProductStatistics();

    },
    methods: {
        getTotal(type) {
            this.$axios
                .get('/interfaceApi/report/largescreen/xsjg/tj/' + this.Year + '/' + this.Month + '/' + type)
                .then(res => {
                    if (type === 0) {
                        this.hntTotal = res;
                    } else {
                        this.sjTotal = res;
                    }

                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        getStatistics(type) {
            this.$axios
                .get('/interfaceApi/report/largescreen/xsjg/' + this.Year + '/' + this.Month + '/' + type)
                .then(res => {
                    if (type === 0) {
                        this.hntData = res;
                        this.hntChart();
                    } else {
                        this.sjData = res;
                        this.sjChart();
                    }
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        getProductStatistics() {
            this.$axios
                .get('/interfaceApi/report/largescreen/xsjg/cp/' + this.Year + '/' + this.Month + '/' + 0)
                .then(res => {
                    this.sjData = res;
                    this.sjChart();
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        sjChart() {
            const myChart = this.$echarts.init(document.getElementById('sjChart'));
            const xdata = [];
            const listAll = this.sjData.list;
            const name = this.sjData.name;
            const newData = [];

            this.sjData.month.forEach(ele => {
                xdata.push(ele + '月');
            });

            const list2 = [];
            name.forEach(Element => { // 编号名称
                this.sjData.month.forEach(ele => { // 月份
                    list2.push({
                        cpbh: Element,
                        xsdj: 0,
                        xsn: this.Year,
                        xsy: ele,
                    });
                });
            });

            list2.forEach(item => {
                listAll.forEach(jtem => {
                    if (item.cpbh === jtem.cpbh && item.xsy === jtem.xsy) {item.xsdj = jtem.xsdj;}
                });
            });

            this.sjData.name.forEach(ele => {
                const list = list2.filter(item => {
                    return item.cpbh === ele;
                });
                newData.push({
                    name: ele,
                    list: list,
                });
            });

            newData.forEach(item => {
                const arr = [];
                item.list.forEach(jtem => {
                    arr.push(jtem.xsdj);
                });
                item.data = arr;

            });

            const data = newData;
            const series = [];
            const color = ['#449FF3', '#F8924A', '#FA8436', '#56AC9D', '#A170D1', '#4EA496', '#F2E341', '#449FF3', '#F8924A', '#FA8436', '#56AC9D'];
            data.forEach((item, index) => {
                series.push({
                    name: item.name,
                    type: 'line',
                    label: {
                        show: false,
                        position: 'top',
                        distance: 0,
                        color: '#519FF4',
                        fontWeight: 'bolder',
                        fontSize: 12,
                        formatter: '{c}',
                        width: 18,
                        height: 22,
                        align: 'center',
                        lineHeight: 20,
                    },
                    lineStyle: {
                        normal: {
                            color: color[index], // 线条颜色
                        },
                    },
                    itemStyle: {
                        color: color[index],
                        borderColor: color[index],
                    },
                    // areaStyle: {
                    //     normal: {
                    //         color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    //             offset: 0,
                    //             color: 'rgba(81, 159, 244, 1)',
                    //         },
                    //         {
                    //             offset: 1,
                    //             color: 'rgba(81, 159, 244, 0.2)',
                    //         },
                    //         ], false),
                    //     },
                    // },
                    data: item.data,
                    z: 10,
                });
            });

            const option = {
                grid: {
                    left: '10%',
                    top: '40%',
                    bottom: '12%',
                    right: '0%',
                },
                legend: {
                    data: name,
                    left: 'right',
                    selectedMode: true,
                    top: '20',
                    textStyle: {
                        color: '#ccc',
                    },
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                        let str = '';
                        for (let i = 0; i < params.length; i++) {
                            if (params[i].seriesName !== '') {
                                str
                        += params[i].name
                        + ':'
                        + params[i].seriesName
                        + ' '
                        + params[i].value
                        + '<br/>';
                            }
                        }
                        return str;
                    },
                },
                xAxis: {
                    data: xdata,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                            fontSize: 10,
                        },
                    },
                },
                yAxis: [{
                    splitNumber: 4,
                    name: '(元/方)',
                    nameTextStyle: {
                        align: 'right',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                        },
                    },
                    splitArea: {
                        areaStyle: {
                            color: 'rgba(255,255,255,.5)',
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#ccc',
                            width: 1,
                            type: 'dashed',
                        },
                    },
                },
                ],
                series: series,
                //     {
                //     name: '每月价格',
                //     type: 'line',
                //     label: {
                //         show: true,
                //         position: 'top',
                //         distance: 0,
                //         color: '#519FF4',
                //         fontWeight: 'bolder',
                //         fontSize: 12,
                //         formatter: '{c}',
                //         width: 18,
                //         height: 22,
                //         align: 'center',
                //         lineHeight: 20,
                //     },
                //     lineStyle: {
                //         normal: {
                //             color: '#519FF4', // 线条颜色
                //         },
                //     },
                //     itemStyle: {
                //         color: '#519FF4',
                //         borderColor: '#519FF4',
                //     },
                //     areaStyle: {
                //         normal: {
                //             color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                //                 offset: 0,
                //                 color: 'rgba(81, 159, 244, 1)',
                //             },
                //             {
                //                 offset: 1,
                //                 color: 'rgba(81, 159, 244, 0.2)',
                //             },
                //             ], false),
                //         },
                //     },
                //     data: data,
                //     z: 10,
                // },
                // {
                //     name: '年平均价',
                //     type: 'line',
                //     label: {
                //         show: true,
                //         position: 'top',
                //         distance: 0,
                //         color: '#A170D1',
                //         fontWeight: 'bolder',
                //         fontSize: 12,
                //         formatter: '{c}',
                //         width: 18,
                //         height: 22,
                //         align: 'center',
                //         lineHeight: 20,
                //     },
                //     lineStyle: {
                //         normal: {
                //             color: '#A170D1', // 线条颜色
                //         },
                //     },
                //     itemStyle: {
                //         color: '#fff',
                //         borderColor: '#A170D1',
                //         borderWidth: 1,
                //     },
                //     areaStyle: {
                //         normal: {
                //             color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                //                 offset: 0,
                //                 color: 'rgba(161, 112, 209, 1)',
                //             },
                //             {
                //                 offset: 1,
                //                 color: 'rgba(161, 112, 209, 0.2)',
                //             },
                //             ], false),
                //         },
                //     },
                //     data: [100, 130, 50, 18, 20],
                //     z: 10,
                // }
            };
            myChart.setOption(option, true);
        },
        hntChart() {
            const myChart = this.$echarts.init(document.getElementById('hntChart'));
            const xdata = [];
            const data = [];
            this.hntData.forEach(item => {
                xdata.push(item.xsy + '月');
                data.push(item.xsdj);
            });
            const option = {
                grid: {
                    left: '10%',
                    top: '20%',
                    bottom: '12%',
                    right: '0%',

                },
                legend: {
                    left: 'right',
                    selectedMode: false,
                    top: '20',
                    textStyle: {
                        color: '#ccc',
                    },
                    pageIconColor: '#56AC9D',
                },
                xAxis: {
                    data: xdata,
                    // boundaryGap: ['20%', '20%'],
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                            fontSize: 10,
                        },
                    },
                },
                yAxis: [{
                    splitNumber: 4,
                    name: '(元/方)',
                    nameTextStyle: {
                        align: 'right',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                        },
                    },
                    splitArea: {
                        areaStyle: {
                            color: 'rgba(255,255,255,.5)',
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#ccc',
                            width: 1,
                            type: 'dashed',
                        },
                    },
                },
                ],
                series: [{
                    name: '每月价格',
                    type: 'line',
                    label: {
                        show: true,
                        position: 'top',
                        distance: 0,
                        color: '#56AC9D',
                        fontWeight: 'bolder',
                        fontSize: 12,
                        formatter: '{c}',
                        width: 18,
                        height: 22,
                        align: 'center',
                        lineHeight: 20,
                    },
                    lineStyle: {
                        normal: {
                            color: '#56AC9D', // 线条颜色
                        },
                    },
                    itemStyle: {
                        color: '#56AC9D',
                        borderColor: '#56AC9D',
                        borderWidth: 1,
                    },
                    areaStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(86, 172, 157, 1)',
                            },
                            {
                                offset: 1,
                                color: 'rgba(86, 172, 157, 0.2)',
                            },
                            ], false),
                        },
                    },
                    data: data,
                    z: 10,
                },
                // {
                //     name: '年平均价',
                //     type: 'line',
                //     label: {
                //         show: true,
                //         position: 'top',
                //         distance: 0,
                //         color: '#FA8436',
                //         fontWeight: 'bolder',
                //         fontSize: 12,
                //         formatter: '{c}',
                //         width: 18,
                //         height: 22,
                //         align: 'center',
                //         lineHeight: 20,
                //     },
                //     lineStyle: {
                //         normal: {
                //             color: '#FA8436', // 线条颜色
                //         },
                //     },
                //     itemStyle: {
                //         color: '#FA8436',
                //         borderColor: '#FA8436',
                //     },
                //     areaStyle: {
                //         normal: {
                //             color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                //                 offset: 0,
                //                 color: 'rgba(250, 132, 54, 1',
                //             },
                //             {
                //                 offset: 1,
                //                 color: 'rgba(250, 132, 54, 0.2)',
                //             },
                //             ], false),
                //         },
                //     },
                //     data: [387.37, 387.37, 387.37, 387.37, 387.37],
                //     z: 10,
                // },
                ],
            };
            myChart.setOption(option, true);
        },
    },
};
</script>

<style lang="stylus">
    .jia-wrapper
        // margin-top 20rpx
        .chart-item
            padding 15rpx
            background #ffffff
            &:last-child
                margin-top 15rpx
            p
                font-size 16rpx
                font-weight 600
                color rgba(51,51,51,1)
                line-height 36px
            .total-wrapper
                display flex
                justify-content space-between
                .total-item
                    width 150rpx
                    height 30rpx
                    border 2rpx solid rgba(234,234,234,1)
                    font-size 10rpx
                    line-height 26rpx
                    text-align center
                    span
                        font-size 14rpx
                        line-height 26rpx
                    &:first-child
                        span
                            color #4486D5
                    &:last-child
                        span
                            color #F8924A
            .chart-wrapper
                height 240rpx
                width 100%
</style>